export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_11149_MARK_AS_READ': 'Mark as Read',
    '_11150_MARK_AS_UNREAD': 'Mark as Unread',
    '_7424_DELETE': 'Delete'
};
